import { render } from "./form.vue?vue&type=template&id=a2c34744"
const script = {}
script.render = render

export default script